var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHospitalizationDepartment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6FA9FF",
  d: "M21 6v3H3V0H0v18h3v-3h18v3h3V6h-3Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#154FA6",
  d: "M5.1 7V3c3.2 0 4 2.667 4 4h-4Z"
})));
export default SvgHospitalizationDepartment;